// Home.js
import React from 'react';
import AchievementsPage from './AchievementsPage';

const Achievements = () => {
  return (
    <div>
          <a href="#Achievements" style={{ textDecoration: 'none' }}><AchievementsPage /></a>
    </div>
  );
};

export default Achievements;
